import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FlexBetween from "./FlexBetween";
import { useDispatch, useSelector } from "react-redux";
import { setMode } from "state/global";
import { logout } from "state/auth";
import {
  AppBar,
  IconButton,
  InputBase,
  Toolbar,
  useTheme,
  Box,
  Typography,
} from "@mui/material";
import {
  LightModeOutlined,
  DarkModeOutlined,
  Menu as MenuIcon,
  Search,
  LogoutOutlined,
  ArrowDropDownOutlined,
} from "@mui/icons-material";
import { APP_VERSION } from "data";

import photo from "../assets/photo_color.png";

const Navbar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { balance, email, authenticated } = useSelector(
    (state) => state.authentication.user
  );

  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <AppBar
      sx={{
        position: "static",
        background: "none",
        boxShadow: "none",
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        {/* LEFT SIDE */}
        <FlexBetween>
          <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
            <MenuIcon />
          </IconButton>
        </FlexBetween>

        {/* RIGHT SIDE */}
        <FlexBetween gap="1.5rem">
          {/* <Typography sx={{ color: "#000" }}>v{APP_VERSION}</Typography> */}

          {/* THEME MODE SWITCH */}

          {/* <IconButton onClick={() => dispatch(setMode())}>
            {theme.palette.mode === "dark" ? (
              <DarkModeOutlined sx={{ fontSize: "25px" }} />
            ) : (
              <LightModeOutlined sx={{ fontSize: "25px" }} />
            )}
          </IconButton> */}

          <Box display="flex" flexDirection="row" gap="10px">
            <img src={photo} alt="photo-icon" width="20px"></img>
            <Typography
              sx={{ fontWeight: "700", color: theme.palette.primary.main }}
            >
              {balance} credits
            </Typography>
          </Box>

          <IconButton onClick={handleLogout}>
            <LogoutOutlined sx={{ fontSize: "25px" }} />
          </IconButton>
        </FlexBetween>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
